import { bool, shape, string } from 'prop-types'
import { Switch } from 'react-router-dom'
import {
  EDIT_SCHEDULES,
  PLAN_SCHEDULES,
  SCHEDULE_APP_MANAGEMENT,
  VIEW_SCHEDULES,
  WFM_APP_MANAGEMENT,
} from '../../Permissions/permissions.constants'
import { PrivateRoute } from '../../Permissions/PrivateRoute'
import { RedirectToClassic } from '../../Common/RedirectToClassic'
import { AgentSchedules } from './AgentSchedules'
import { IntradayDynamicScheduling } from './IntradayDynamicScheduling'
import { MyAvailability } from './MyAvailability'
import { MySchedule } from './MySchedule'
import { Planning } from './Planning'
import { ScheduleEditManagement } from './ScheduleEditManagement'

export const Schedule = ({ match }) => {
  if (match.isExact) {
    return <RedirectToClassic />
  }
  return (
    <Switch>
      <PrivateRoute path={`${match.url}/agentSchedules`} component={AgentSchedules} permissions={[EDIT_SCHEDULES]} />
      <PrivateRoute
        path={`${match.url}/intradayDynamicScheduling`}
        component={IntradayDynamicScheduling}
        permissions={[PLAN_SCHEDULES]}
      />
      <PrivateRoute path={`${match.url}/myAvailability`} component={MyAvailability} permissions={[VIEW_SCHEDULES]} />
      <PrivateRoute path={`${match.url}/mySchedule`} component={MySchedule} permissions={[VIEW_SCHEDULES]} />
      <PrivateRoute path={`${match.url}/planning`} component={Planning} permissions={[PLAN_SCHEDULES]} />
      <PrivateRoute
        path={`${match.url}/scheduleChangeManagement`}
        component={ScheduleEditManagement}
        permissions={[SCHEDULE_APP_MANAGEMENT, WFM_APP_MANAGEMENT]}
      />
    </Switch>
  )
}

Schedule.propTypes = {
  match: shape({
    isExact: bool.isRequired,
    url: string.isRequired,
  }).isRequired,
}
